import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
// @material-ui
import { Box, Grid, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { withLang } from '_core/hocs/withLang'
import { ArticleList } from '_core/views/ArticleList'
import CardTitle from '_core/components/CardTitle/CardTitle'

// style
import { readingsStyle } from './readingsStyle'

const RawReadings = props => {
  const {
    rowLg,
    rowMd,
    rowSm,
    rowXs,
    classes,
    customColumns,
    getLangString: l,
  } = props

  const {
    config: { ROUTE_URL, ARTICLE_KEY },
  } = useGlobal()

  const inRowLg = rowLg || 4
  const inRowMd = rowMd || 2
  const inRowSm = rowSm || 1
  const inRowXs = rowXs || 1

  const defaultColumns = [
    {
      icon: 'rate_review',
      titleText: 'r._.readings.text.newstitle',
      buttonText: 'r._.readings.control.newsmore',
      path: ARTICLE_KEY.NEWS,
      url: ROUTE_URL.NEWS,
    },
    {
      icon: 'event_note',
      titleText: 'r._.readings.text.eventstitle',
      buttonText: 'r._.readings.control.eventsmore',
      path: ARTICLE_KEY.EVENTS,
      url: ROUTE_URL.EVENTS,
    },
  ]

  const columns = !isEmpty(customColumns) ? customColumns : defaultColumns

  const [isActive, setIsActive] = useState(columns.map(() => true))
  const activeCount = isActive.filter(v => v).length
  const sm = activeCount === 1 ? 12 : 6;
  const md = activeCount === 1 ? 12 : 6;
  const lg = activeCount === 1 ? 12 : 6;
  
  

  const getOnUpdate = index => data => {
    setIsActive(list => {
      const newVal =
        data != null && Array.isArray(data.list) && data.list.length > 0

      if (list[index] === newVal) {
        return list
      }

      return list.map((val, i) => (i === index ? newVal : val))
    })
  }

  const renderColumn = (item, index) => (
    <Grid key={index} item={true} xs={12} sm={sm} md={md} lg={lg} className={classes.column}>
      <CardTitle icon={item.icon} title={l(item.titleText)} marginNone />

      <ArticleList
        path={item.path}
        baseUrl={item.url}
        itemProps={{ hasDate: true }}
        renderEmpty={() => null}
        renderFailure={() => null}
        hasPaging={false}
        onUpdate={getOnUpdate(index)}
        inRowLg={inRowLg / activeCount}
        inRowMd={inRowMd / activeCount}
        inRowSm={inRowSm}
        inRowXs={inRowXs}
      />

      <Box display="flex" flexDirection="row-reverse">
        <Link to={item.url}>
          <Button>{l(item.buttonText)}</Button>
        </Link>
      </Box>
    </Grid>
  )

  return (
    <Grid container={true} className={classes.root}>
      {columns.map((data, index) =>
        isActive[index] ? renderColumn(data, index) : null
      )}
    </Grid>
  )
}

RawReadings.defaultProps = {}

RawReadings.propTypes = {
  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  rowLg: PropTypes.number,
  rowMd: PropTypes.number,
  rowSm: PropTypes.number,
  rowXs: PropTypes.number,
  langInfo: PropTypes.object,
  customColumns: PropTypes.array,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const Readings = withLang(withStyles(readingsStyle)(RawReadings))
